import script from "./Language.vue?vue&type=script&setup=true&lang=js"
export * from "./Language.vue?vue&type=script&setup=true&lang=js"

import "./Language.vue?vue&type=style&index=0&id=60540dac&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60540dac"]])

export default __exports__